module.exports = __webpack_public_path__ + "img/lv6.778b8d70.png";